import React from 'react'
import ReactDOM from 'react-dom'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { faqList } from '../faqList'
import { useStyles } from '../styles/FaqStyle'

export default function Faq() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.mainTitle} align="center">FAQ</Typography>
      <Typography variant="h6" className={classes.cateTitle}>コンサルティングセッション</Typography>
      {faqList.map((item, index) => (
        item.cate === 'コンサルティングセッション' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>コンサルティングセッション（欠席・振替）</Typography>
      {faqList.map((item, index) => (
        item.cate === 'コンサルティングセッション（欠席・振替）' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>アセスメントテスト／アセスメント模試</Typography>
      {faqList.map((item, index) => (
        item.cate === 'アセスメントテスト／アセスメント模試' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>オンライン英会話サービス</Typography>
      {faqList.map((item, index) => (
        item.cate === 'オンライン英会話サービス' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>受講期間</Typography>
      {faqList.map((item, index) => (
        item.cate === '受講期間' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>サポート</Typography>
      {faqList.map((item, index) => (
        item.cate === 'サポート' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>支払い</Typography>
      {faqList.map((item, index) => (
        item.cate === '支払い' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>オンライン</Typography>
      {faqList.map((item, index) => (
        item.cate === 'オンライン' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
      <Typography variant="h6" className={classes.cateTitle}>その他</Typography>
      {faqList.map((item, index) => (
        item.cate === 'その他' && (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              component="section"
            >
              <span className={classes.span}>Q.　</span>
              <Typography className={classes.heading} component="h2">{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                dangerouslySetInnerHTML={{ __html: item.a }}
                component="p"
              />
            </AccordionDetails>
          </Accordion>
        )
      ))}
    </div>
  )
}

if (document.getElementById('faq')) {
  ReactDOM.render(
    <Faq />,
    document.getElementById('faq')
  )
}